<template>
  <div>
    <!-- sub title -->
    <v-subheader class="px-2 all-menu-sub">
      <!-- sub title icon (기준: index) -->
      <icon-star v-if="categoryCd === '100'" class="sub-title-icon" />
      <icon-my-folder v-else-if="categoryCd === '200'" class="sub-title-icon" />
      <icon-edit v-else-if="categoryCd === '300'" class="sub-title-icon" />
      <icon-application-cancel
        v-else-if="categoryCd === '400'"
        class="sub-title-icon"
      />
      <icon-satis-survey
          v-else-if="categoryCd === '500'"
          class="sub-title-icon"
      />
      <icon-contact
          v-else-if="categoryCd === '600'"
          class="sub-title-icon"
      />
      <!--icon-satis-survey v-else class="sub-title-icon" /-->

      <!-- sub title name -->
      <span class="ml-2">{{ categoryNm }}</span>
    </v-subheader>

    <!-- detail menu list -->
    <v-list-item-group active-class="text--accent-4">
      <v-list-item
        v-for="(item, i) in menuList"
        :key="i"
        class="pl-6 pr-2"
        @click="toPage(item, i)"
      >
        <v-list-item-content>
          <v-list-item-title class="d-flex">
            {{ item.menuNm }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-icon v-if="item.pathName">
          <v-icon color="#9fa6ae">mdi-chevron-right</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list-item-group>
  </div>
</template>

<script>
/* 전체메뉴 메뉴목록 컴포넌트 */
import IconStar from '@/assets/customIcon/IconStar.vue';
import IconMyFolder from '@/assets/customIcon/IconMyFolder.vue';
import IconEdit from '@/assets/customIcon/IconEdit.vue';
import IconApplicationCancel from '@/assets/customIcon/IconApplicationCancel.vue';
import IconEtc from '@/assets/customIcon/IconEtc.vue';
import routerConstants from '@/const/routerConstants';
import routerNames from '@/const/routerConstants';
import IconSatisSurvey from "@/assets/customIcon/IconSatisSurvey.vue";
import IconContact from "@/assets/customIcon/IconContact.vue";

export default {
  props: {
    categoryNm: {
      type: String,
      required: true,
    },
    categoryCd: {
      type: String,
      default: '0',
    },
    menuList: {
      type: Array,
      required: true,
    },
  },

  methods: {
    /* 페이지 이동 */
    toPage(item) {

      const pathName = item.pathName;
      if(pathName === 'educationSurvey'){
        this.$router.push('surveyBoxView');
      }else if(pathName === 'annualHolidaySta'){
        this.$router.push(routerNames.VacationMyWorkHolidayMain);
      }else if(pathName === routerConstants.Application){
        const applicationCdList = item.applCd.split(',');
        if(applicationCdList.length > 1 && item.menuCd === '302'){
          this.$router.push({
            name : routerNames.ReCertAppStep
            , params : {
              applCd: item.applCd
              , gntGubunCd: item.gntGubunCd
            }
          });
        }else if(applicationCdList.length > 1 && item.menuCd !== '302'){
          this.$router.push({
            name : routerNames.LeaAbsAppStep1
            , params : {
              applCd: item.applCd
              , gntGubunCd: item.gntGubunCd
            }
          });
        }else{
          this.$store.dispatch('ELA/FETCH_MENU_ACTION',  {
            applCd: item.applCd
            , gntGubunCd: item.gntGubunCd
          }).then((result) => {
            this.$router.push({
              name : result
              , params : {
                applCd: item.applCd
                , gntGubunCd: item.gntGubunCd
              }
            });
          });
        }
      }else{
        this.$router.push(pathName);
      }


      // let routerName = item.pathName;
      // const applParam = {
      //   applCd: item.applCd,
      //   gntGubunCd: item.gntGubunCd,
      // };
      //
      // if (routerName === routerConstants.Application) {
      //   if (item.applCd.split(',').length > 1 && item.menuCd !== '302') {
      //     //휴복직신청
      //     routerName = routerNames.LeaAbsAppStep1;
      //   } else if (item.applCd.split(',').length > 1 && item.menuCd === '302') {
      //     //재증명신청
      //     routerName = routerNames.ReCertAppStep;
      //   } else {
      //     routerName = await this.$store.dispatch(
      //       'ELA/FETCH_MENU_ACTION',
      //       applParam,
      //     );
      //   }
      // } else if (routerName === 'educationSurvey') { // 설문조사
      //   this.$router.push('surveyBoxView');
      //   return;
      // } else if (routerName === 'annualHolidaySta') { // 근태/휴가 현황
      //   routerName = routerNames.VacationMyWorkHolidayMain;
      // }
      //
      // this.$router.push({ name: routerName, params: { applParam } });
    },
  },

  components: {
    IconSatisSurvey,
    IconStar,
    IconMyFolder,
    IconEdit,
    IconApplicationCancel,
    IconEtc,
    IconContact,
  },
};
</script>

<style scoped>
.v-subheader .sub-title-icon {
  width: 24px;
  height: 24px;
}

.v-list--nav .v-list-item:not(:last-child):not(:only-child) {
  margin-bottom: 0px;
}
</style>
